import { sendError } from 'src/services/event-message/event-message.service';
import { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import i18n from 'i18next';
import axios from './index';
import refreshTokenService from '../services/refresh-token/refresh-token.service';
import { ErrorCode } from 'src/enums/error-code.enum';
interface ErrorContainer {
    errorHeader: string;
    errorCode: string;
}
const { t } = i18n;
const genericErrorText = 'SharedDesignError.Retryable.Text';
const unauthorizedCode = 401;
const conflictCode = 409;
const approvedState = 'approved';
const rejectedState = 'rejected';
const textForApprovedState = 'SharedDesignError.DesignApproved.Text';
const textForRejectedState = 'SharedDesignError.DesignRejected.Text';
const textForNoneState = 'Errors.Error_500_Title';

const genericError: ErrorContainer = {
    errorHeader: genericErrorText,
    errorCode: ErrorCode.BadRequest,
};

const httpErrorStatuses: ReadonlyMap<number, ErrorContainer> = new Map<number, ErrorContainer>([
    [400, { errorHeader: 'Errors.Error_400_Title', errorCode: ErrorCode.BadRequest }],
    [403, { errorHeader: 'SharedDesignError.NoAssetAccess.Text', errorCode: ErrorCode.NotAcces }],
    [404, { errorHeader: 'Errors.Error_404_Title', errorCode: ErrorCode.NotFound }],
    [408, { errorHeader: genericErrorText, errorCode: ErrorCode.RequestTimeout }],
    [500, { errorHeader: genericErrorText, errorCode: ErrorCode.ServerError }],
    [503, { errorHeader: genericErrorText, errorCode: ErrorCode.ServiceUnavailable }],
    [504, { errorHeader: genericErrorText, errorCode: ErrorCode.GatawayTimeout }],
]);

const onResponse = (response: AxiosResponse): AxiosResponse => {
    return response;
};

const onResponseError = (error: AxiosError<any, boolean>): Promise<any> => {
    if (error?.message === ErrorCode.UpdateToken) return Promise.reject(error);
    let errorObject = genericError;
    const response = error?.response;
    if (response) {
        const request = error.config;

        if (response.status === unauthorizedCode) {
            return handleUnauthorized(request);
        }

        errorObject = getError(response);
    }
    console.log(errorObject);
    sendError({
        errorCode: errorObject.errorCode,
        errorHeader: t(errorObject.errorHeader),
    });
    return Promise.reject(error);
};

const handleUnauthorized = (request: InternalAxiosRequestConfig<boolean>) => {
    return refreshTokenService.checkAndUpdateToken(true).then(() => axios(request));
};

const getError = (response: any): ErrorContainer => {
    const status = response.status;
    if (status === conflictCode) {
        const state = response.data?.errorDetails?.currentStatus;
        switch (state) {
            case approvedState:
                return {
                    errorHeader: textForApprovedState,
                    errorCode: ErrorCode.Conflict,
                };
            case rejectedState:
                return {
                    errorHeader: textForRejectedState,
                    errorCode: ErrorCode.Conflict,
                };
            default:
                return {
                    errorHeader: textForNoneState,
                    errorCode: ErrorCode.Conflict,
                };
        }
    }
    return httpErrorStatuses.get(response.status) ?? genericError;
};

export function setupErrorInterceptorTo(axiosInstance: AxiosInstance) {
    axiosInstance.interceptors.response.use(onResponse, onResponseError);
}
